<template>
    <div class="h-screen bg-white">
        <div class="w-full">
            <div class="flex">
                <div class="w-full flex flex-col">
                    <div class="w-full flex flex-wrap">
                        <slot></slot>

                        <div class="w-1/2 shadow-2xl">
                            <img
                                class="object-cover w-full h-screen hidden md:block"
                                :src="'/images/login_image.jpg'"
                                alt="logo"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
